<template>
  <div class="tool-area-admin">
    <!-- 未折叠状态 -->
    <div v-if="!isMobile">
        <!-- 新建按钮 -->
        <div class="new-btn" @click="setClearFn">
            <img :src="newIcon" alt="" class="btn_icon icon_no_hover" />
            <img :src="newIconHover" alt="" class="btn_icon icon_hover" />
            <div class="btn_text">新建会话 Ctrl+K</div>
        </div>

        <!-- 普通按钮 -->
        <div class="default-btn default-btn-hover" @click="goTankList" v-if="agentList && agentList.length">
            <img :src="tankIcon" alt="" class="btn_icon" />
            <div class="btn_text">维盾智库</div>
        </div>
        <div class="tank-area-admin" v-if="agentList && agentList.length">
            <div class="default-btn default-btn-hover" :class="{
              'default-btn-hove-active': (currentAgentData.agentId == item.agentId && $route.path=='/tank')
            }" v-for="(item,index) in dataSource" :key="index" >
                <img :src="imgUrl(item)" alt="" class="btn_icon" />
                <div class="btn_text" @click="goTank(item)">{{ item.agentName }}</div>
                <a-dropdown>
                    <img :src="expandIcon" alt="" class="expand_icon btn_icon" />
                    <a-menu slot="overlay">
                        <a-menu-item class="menu-item create-hover" @click="setTankClearFn(item)">
                            <img :src="newMenuIcon" alt="" class="menu-icon icon_no_hover" />
                            <img :src="newMenuIconHover" alt="" class="menu-icon icon_hover" />
                            <div class="menu-text">新建会话</div>
                        </a-menu-item>
                        <a-menu-item class="menu-item delete-hover" @click="setAgentCancelTop(item)">
                            <img :src="topIcon" alt="" class="menu-icon icon_no_hover" />
                            <img :src="topIconHover" alt="" class="menu-icon icon_hover" />
                            <div class="menu-text">取消置顶</div>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </div>
        </div>

        <!-- 历史 -->
        <div class="default-btn" style="cursor: default;margin-bottom: 0;">
            <img :src="historyIcon" alt="" class="btn_icon" />
            <div class="btn_text">历史会话</div>
        </div>
        <div class="history-area-admin">
            <div class="empty-text" v-if="!isLogined">登录以同步历史会话</div>
            <div class="empty-text" v-if="hisData.length == 0 && isLogined">暂无历史会话</div>
            <div v-else>
                <div class="default-btn default-btn-hover" :class="{
                  'default-btn-hove-active': $route.query.id == item.id
                }" style="margin-bottom: 0;" v-for="(item,index) in hisData" :key="index" @click="setMsg(item)">
                    <div class="w-20"></div>
                    <div class="btn_text" style="color: #666666;">{{ item.conversationName }}</div>
                    <!-- <a-dropdown>
                        <img :src="expandIcon" alt="" class="expand_icon btn_icon" />
                        <a-menu slot="overlay">
                            
                            <a-menu-item class="menu-item create-hover" @vclick="visible = true;detials = item">
                                <img :src="editeIcon" alt="" class="menu-icon icon_no_hover" />
                                <img :src="editeIconHover" alt="" class="menu-icon icon_hover" />
                                <div class="menu-text">编辑标题</div>
                            </a-menu-item>
                            <a-menu-item class="menu-item delete-hover">
                                <img :src="deleteIcon" alt="" class="menu-icon icon_no_hover" />
                                <img :src="deleteIconHover" alt="" class="menu-icon icon_hover" />
                                <div class="menu-text">删除</div>
                            </a-menu-item>

                        </a-menu>
                    </a-dropdown> -->
                </div>

                <div v-if="hisData.length" class="default-btn default-btn-hover" :class="{
                  'default-btn-hove-active': $route.path=='/history'
                }" @click="goHistory">
                    <div class="w-20"></div>
                    <div class="btn_text" style="color: #2C2C2C;">查看全部</div>
                </div>
            </div>
            <!-- Bug 131108: 维盾前端：历史会话列表，当主智库没有会话历史时，其他智库有过历史，是无法查看到历史会话的 -->
            <!--<div v-if="isLogined" class="default-btn default-btn-hover" @click="goHistory">-->
            <!--  <div class="w-20"></div>-->
            <!--  <div class="btn_text" style="color: #2C2C2C;">查看全部</div>-->
            <!--</div>-->
        </div>

    </div>
    <!-- 折叠状态 -->
    <div style="display: flex;align-items: center;flex-direction: column;margin-top:20px;" v-else>
        <div class="btn-div-img" @click="onChange">
            <img :src="navExpand" alt="" class="nav-fold" />
        </div>
        <div class="btn-div-img" @click="setClearFn">
            <img :src="newIcon" alt="" class="nav-fold" />
        </div>
        <div class="btn-div-img" @click="goTankList" v-if="agentList && agentList.length">
            <img :src="tankIcon" alt="" class="nav-fold" />
        </div>
        <div class="btn-div-img" @click="goHistory">
            <img :src="historyIcon" alt="" class="nav-fold" />
        </div>
    </div>
    

    <!-- <EditeModal :visible.sync='visible' @onEdite='onEdite'></EditeModal> -->
  </div>
</template>

<script>
import newIcon from '@/assets/new-icon.png'
import newIconHover from '@/assets/new-icon-hover.png'
import tankIcon from '@/assets/tank-icon.png'
import defultIcon from '@/assets/defult-icon.png'
import expandIcon from '@/assets/expand-icon.png'
import historyIcon from '@/assets/history-icon.png'
import newMenuIcon from '@/assets/new-menu-icon.png'
import topIcon from '@/assets/top-icon.png'
import topIconHover from '@/assets/top-icon-hover.png'
import newMenuIconHover from '@/assets/new-menu-icon-hover.png'
import editeIcon from '@/assets/edite-icon.png'
import editeIconHover from '@/assets/edite-icon-hover.png'
import deleteIcon from '@/assets/delete-icon.png'
import deleteIconHover from '@/assets/delete-icon-hover.png'
import navExpand from '@/assets/nav-expand.png'
import { mapState,mapMutations,mapActions } from 'vuex'
import { downloadFile } from '@/services/agent'
import { agentCancelTop } from '@/services/agent'
// import EditeModal from '@/views/history/components/EditeModal.vue'
// import { deleteConversations,conversationsName } from '@/services/history'
export default {
    data() {
        return {
            newIcon,
            newIconHover,
            tankIcon,
            defultIcon,
            expandIcon,
            historyIcon,
            newMenuIcon,
            topIcon,
            topIconHover,
            newMenuIconHover,
            editeIcon,
            editeIconHover,
            deleteIcon,
            deleteIconHover,
            navExpand,
            visible:false,
            detials:null
        }
    },
    computed:{
        ...mapState('mobile',['isMobile']),
        ...mapState('channel',['isLogin']),
        ...mapState('history',['hisDataList']),
        ...mapState('agent', ['agentList','topList','defaultConfig','currentAgentData']),
        ...mapState('user', ['userInfo']),
        imgUrl(){
            return function(item){
                if(item.annex){
                    return downloadFile(item.annex)
                }
                return defultIcon
            }
        },
        isLogined(){
            return this.isLogin ? localStorage.getItem('web_login_token') : true
        },
        hisData(){
          if(this.userInfo){
            return this.removeDuplicatesByMap(this.hisDataList).slice(0,5)
          }else{
            return []
          }
        },
        dataSource(){
            return this.topList.slice(0,10)
        }
    },
    // components:{
    //     EditeModal
    // },
    methods: {
        ...mapMutations('mobile',['setMobile']),
        ...mapMutations('message',['setClear']),
        ...mapMutations('agent',['setCurrentAgent','clearCurrentAgent']),
        ...mapActions('agent',['getAgentList']),
        removeDuplicatesByMap(arr) {
          const map = new Map();
          arr.forEach(item => {
            if (!map.has(item.id)) {
              map.set(item.id, item);
            }
          });
          return Array.from(map.values());
        },
        // async onEdite(){
        //     try{
        //         await conversationsName(
        //             this.detials.id,
        //             name,
        //             this.userInfo.id,
        //             this.detials.id
        //         )
        //         this.$message.success('修改成功')
        //         this.getConversations(this.activeKey)
        //     }catch(e){
        //         this.$message.error('修改失败')
        //     }
        // },
        goHistory(){
            this.$router.push('/history')
            this.$emit('drawerChange')
        },
        goTank(val){
            this.setCurrentAgent(val)
          this.setClear()
           this.$emit('drawerChange')
          if(this.$route.path != '/tank'){
            this.$router.push('/tank')
          }
        },
        goTankList(){
            this.$router.push('/tankList')
            this.$emit('drawerChange')
        },
        onChange(){
            this.setMobile(false)
        },
        // 历史消息点击
        setMsg(item){
          if(item.agentId == this.defaultConfig.agentId){
            this.$router.replace('/ai?id=' + item.conversationId)
          }else{
            this.$router.replace('/tank?id=' + item.conversationId)
            let { agentId } = item
            let agent = this.agentList.filter(item => item.agentId == agentId)
            this.setCurrentAgent(agent[0])
          }
          this.$emit('drawerChange')
        },
        // 处理键盘快捷键
        handleKeyDown(event) {
            // 检测Ctrl+K组合键
            if (event.ctrlKey && event.key === 'k') {
                // 阻止默认行为（如浏览器的搜索功能）
                event.preventDefault();
                this.setClearFn()
            }
        },
        setClearFn(){
            if(this.$router.fullPath != '/ai'){
                this.$router.replace('/ai')
            }
            this.clearCurrentAgent()
            this.$emit('drawerChange')
            setTimeout(() => {
                this.setClear()
            }, 500)
        },
        setTankClearFn(item){
            this.setCurrentAgent(item)
            if(this.$router.fullPath != '/tank'){
                this.$router.replace('/tank')
            }
            this.$emit('drawerChange')
            setTimeout(() => {
                this.setClear()
            }, 500)
        },
        async setAgentCancelTop(val){
            let res = await agentCancelTop(val.agentId)
            if(res.code == 200){
                this.$message.success(res.message)
                this.getAgentList()
            }
        },
    },
    mounted() {
        // 添加全局键盘事件监听
        document.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
        // 移除全局键盘事件监听
        document.removeEventListener('keydown', this.handleKeyDown);
    },
}
</script>

<style lang="scss" scoped>
.btn-div-img{
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-bottom: 20px;
    .nav-fold{
        width: 20px;
        height: 20px;
    }
}
.btn-div-img:hover{
    background: rgba(1,10,28,0.05);
    border-radius: 4px;
}

.menu-item{
    display: flex;
    align-items: center;
    padding: 8px 16px;
    .menu-icon{
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .menu-text{
        font-size: 14px;
        color: #666666;
        line-height: 19px;
    }
}
.menu-item:hover{
    background: transparent;
}
.create-hover:hover{
    .icon_no_hover{
        display: none;
    }
    .icon_hover{
        display: inline-block;
    }
    .menu-text{
        color: $base_color;
    }
}
.delete-hover:hover{
    .menu-text{
        color: #FF3B30;
    }
    .icon_no_hover{
        display: none;
    }
    .icon_hover{
        display: inline-block;
    }
}

.tool-area-admin{
    padding: 20px 0;
}
.history-area-admin{
    .empty-text{
        font-size: 14px;
        color: #A6A6A6;
        line-height: 20px;
        padding: 0px 10px;
        padding-left: 35px;
        //text-align: center;
    }
}
.w-20{
    width: 28px;
}
.default-btn{
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    cursor: pointer;
    margin-bottom: 8px;
}
.default-btn-hover:hover{
    background: rgba(1,10,28,0.05);
    border-radius: 8px;
    .expand_icon{
      display: block !important;
    }
}
.default-btn-hove-active{
  background: rgba(1,10,28,0.05);
  border-radius: 8px;
}
.expand_icon:hover{
  background: rgba(0,0,0,0.1);
  border-radius: 4px;
}
.new-btn{
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #EBEEF5;
    display: flex;
    cursor: pointer;
    margin-bottom: 8px;
}
.new-btn:hover{
    //background: rgba(26,94,240,0.05);
  border-color: $base_color !important;
    border-radius: 8px;
    border: 1px solid #EBEEF5;
    .btn_text{
        color: $base_color;
    }
    .icon_no_hover{
        display: none;
    }
    .icon_hover{
        display: inline-block;
    }
}
.expand_icon{
    width: 16px;
    height: 16px;
    display: none;
}
.btn_icon{
    width: 20px;
    height: 20px;
    margin-right: 8px;
}
.btn_text{
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 20px;
    flex: 1;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
}
.icon_hover{
    display: none;
}

</style>